<template>
  <div>
    <nav-bar />
    <div class="outside">
      <div class="container content">
        <el-container style="height: 700px; border: 1px solid #eee">
          <el-aside width="230px" style="background-color: rgb(238, 241, 246)">
            <el-menu class="el-menu-vertical-demo" :default-active="activePath" @open="handleOpen" @close="handleClose" :unique-opened="true">
              <el-submenu :index="key.toString()" v-for="(item, key) in notices" :key="item.id">
                <template slot="title">
                  <span>{{ item.name }}</span>
                </template>
                <el-menu-item :index="subKey.toString()" v-for="(subItem, subKey) in item.children" :key="subItem.id" @click="saveNavState('/' + subItem.id, subItem.id), handelClick(subItem.id)">
                  <template slot="title">
                    <span>{{ subItem.title }}</span>
                  </template>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-aside>
          <el-main style="width: 100%">
            <div class="item">
              <div class="title">
                <img class="gonggao" src="~assets/icons/gonggao.png" />
                {{ content.title }}
              </div>
              <div class="info">
                <div class="info-content" v-html="content.content"></div>
              </div>
              <br /><br />
              <div class="addtime" style="text-align: end">
                <p>发布时间：{{ content.createtime }}</p>
                <p class="sdf">作者：{{ $store.getters.getSiteInfo.name }}</p>
              </div>
            </div>
          </el-main>
        </el-container>
      </div>
    <bottom-footer/>
    </div>
  </div>
</template>

<script>
import NavBar from 'components/navbar/NavBar'
import BottomFooter from 'components/bottomfooter/BottomFooter.vue'
// import NoticeListItem from './childComps/NoticeListItem'
import { getNoticeAll } from 'network/api'

export default {
  components: {
    NavBar,
    BottomFooter
    // NoticeListItem
  },
  data () {
    return {
      notices: [],
      content: [],
      activePath: '0' // 被激活的菜单
    }
  },
  created () {
    this.getNoticeAll()
    // this.activePath = window.sessionStorage.getItem('activePath')
  },
  methods: {
    // 保存激活的菜单状态
    saveNavState (path, id) {
      this.activePath = path
      this.getNoticeAll(id)
    },
    handleOpen (key, keyPath) {
      // console.log(key)
      // console.log(keyPath)
      // this.activePath = ''
      // this.notices.forEach(function (item, k) {
      //   // console.log(typeof (key))
      //   // console.log(typeof (k))
      //   if (key.toString() === k.toString()) {
      //     item.children.forEach(function (subItem, subKey) {
      //       console.log(subKey)
      //       if (subKey === 0) {
      //         console.log(subKey, '-----81----')
      //         const id = subKey
      //         console.log(typeof (id))
      //         this.getNoticeAll() // 从这里重新取下id
      //         this.handelClick()
      //       }
      //     })
      //   }
      // })
    },
    handelClick (subItemId) {
      // console.log(subItemId)
      const id = subItemId
      this.getNoticeAll(id)
    },
    handleClose (key, keyPath) {
      // this.activePath = key
      // console.log(key, keyPath)
    },
    // 获取全部公告
    getNoticeAll (params) {
      getNoticeAll(params).then((res) => {
        if (res.code !== 1) { return this.$message({ message: res.msg, type: 'warning' }) }
        if (params) {
          this.content = res.data
        } else {
          this.notices = res.data.list
          // list = JSON.parse(`[${res.value}]`)
          this.content = res.data.content
        }
      })
    }
  }
}
</script>

<style scoped src="styles/views/notice/notice.css">
</style>

<style>
.el-submenu /deep/.el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  min-width: 220px;
  width: 230px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-menu-item:focus /deep/ .el-menu-item:hover {
    outline: 0;
    background-color: #e2e6fd;
    color: #5555f7;
}
.el-tabs__content {
  margin-top: 100px;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.45);
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: #409eff;
  border: 1px solid #409eff;
  background-color: #ffffff;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}
.el-aside {
  color: #333;
}
</style>
